import React, { useState } from "react";
import Setting_User_Table from "../Components/Setting_User_Table";
import { useEffect } from "react";
import Popup from "reactjs-popup";
import { makeRequest } from "../api";
import RecordConflict from "./RecordConflict";
import TigerConflictMap from "../Components/TigerConflictMap";

const TigerConflicts = () => {
  const [render, setRender] = useState(1);
  const [loading, setLoading] = useState(true);
  const [TigerData, setTigerData] = useState([]);
  const [AllTigerData, setAllTigerData] = useState([]);
  const [scroll, setScroll] = useState(true);
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const [count, setCount] = useState(0);

  const [mapView, setMapView] = useState(false);

  useEffect(() => {
    fetchTiger();
  }, [page, render]);

  const AllTigerSetup = (
    tigers,
    existingTigerData = [],
    existingAllTigerData = []
  ) => {
    let result = [];
    let result2 = [];
    tigers.forEach((value) => {
      const dateString = value.conflict_date;
      const dateObj = new Date(dateString);
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZone: "UTC",
      };

      const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
        dateObj
      );

      const obj = {
        "Tiger Name": value.name,
        Age: value.age,
        Latitude: value.lat,
        Longitude: value.long,
        Range: value.range_name,
        Village: value.village_name,
        Image: value.image,
        "Conflict Date": formattedDate,
        Comments: value.comments,
      };
      const obj2 = {
        name: value.name,
        Age: value.name,
        Latitude: value.lat,
        Longitude: value.long,
        Range: value.range_name,
        Village: value.village_name,
        Image: value.image,
        "Conflict Date": formattedDate,
        Comments: value.comments,
        id: value.id,
      };

      result.push(obj);
      result2.push(obj2);
    });

    setTigerData([...existingTigerData, ...result]);
    setAllTigerData([...existingAllTigerData, ...result2]);
  };

  const recordAddHandler = async (close) => {
    close();
    setTigerData([]);
    setAllTigerData([]);
    setRender(0);
    setPage(1);
    setCurrentPage(0);
  };

  const fetchTiger = async () => {
    setScroll(true);
    if (page <= currentPage) {
      setLoading(false);
      return;
    }
    let token = "";
    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      const result = await makeRequest(
        "get",
        `api/v1/identification/tiger_conflicts/?page=${page}&size=10`
      );
      const currentTigerData = TigerData;
      const currentAllTigerData = AllTigerData;

      setCount(result.data.count);
      AllTigerSetup(result.data.data, currentTigerData, currentAllTigerData);
      setCurrentPage(currentPage + 1);
      setScroll(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const toggleMapView = () => {
    setMapView(!mapView);
  };

  return (
    <div className="Setting_User">
      <div className="Setting_User_Header">
        <div>
          <span>Tiger Conflicts</span>
        </div>
        <div className="Setting_User_Attribute">
          <div onClick={toggleMapView} className="Setting_Add_Button">
            <span>{mapView ? "Table View" : "Map View"}</span>
          </div>
          <Popup
            trigger={
              <div className="Setting_Add_Button">
                <span>Record Conflict</span>
              </div>
            }
            modal
            nested
          >
            {(close) => (
              <RecordConflict
                render={render}
                recordAddHandler={recordAddHandler}
                setRender={setRender}
                close={close}
              />
            )}
          </Popup>
        </div>
      </div>
      {mapView ? (
        <TigerConflictMap 
          data={TigerData}
        />
      ) : (
        <Setting_User_Table
          scroll={scroll}
          total={true}
          count={count}
          loading={loading}
          setLoading={setLoading}
          setPage={setPage}
          delete={true}
          data={TigerData}
          currentPage={currentPage}
          page={page}
          type="Tiger Conflicts"
        />
      )}
    </div>
  );
};

export default TigerConflicts;
